import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Buildings, Wrench, Stack, ArrowRight } from "@phosphor-icons/react";

const SECTORS = [
  { id: "costruzioni", label: "Costruzioni", desc: "Edilizia · muratura · intonaci · finiture", icon: Buildings },
  { id: "impiantistica", label: "Impiantistica", desc: "Elettrico · idraulico · gas · termoidraulica", icon: Wrench },
  { id: "entrambi", label: "Costruzioni e Impiantistica", desc: "Tutto insieme · listino completo edile + impianti", icon: Stack },
];

export default function Onboarding() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [step, setStep] = useState(1);
  const [sector, setSector] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [vat, setVat] = useState("");
  const [saving, setSaving] = useState(false);

  const finish = async () => {
    if (!sector) return toast.error("Seleziona un settore");
    setSaving(true);
    try {
      await api.put("/users/onboarding", { sector, company_name: companyName || null, vat: vat || null });
      await refresh();
      toast.success("Configurazione completata!");
      nav("/dashboard");
    } catch (e) {
      toast.error("Errore configurazione");
    } finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white px-6 py-10">
      <div className="max-w-xl mx-auto">
        <div className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] font-bold mb-3">Configurazione · {step}/2</div>
        {step === 1 && (
          <>
            <h1 className="font-heading text-5xl sm:text-6xl font-black uppercase tracking-tighter leading-none mb-3">Scegli il tuo settore</h1>
            <p className="text-[#A3A3A3] mb-8">Carichiamo il listino prezzi giusto per te.</p>
            <div className="space-y-3">
              {SECTORS.map((s) => {
                const Icon = s.icon;
                const active = sector === s.id;
                return (
                  <button key={s.id} data-testid={`sector-${s.id}`} onClick={() => setSector(s.id)}
                    className={`w-full text-left p-5 rounded-md border-2 flex items-center gap-4 transition ${active ? "border-[#FFD600] bg-[#FFD600]/5" : "border-[#333] bg-[#1A1A1A] hover:border-[#666]"}`}>
                    <div className={`w-14 h-14 rounded-md flex items-center justify-center ${active ? "bg-[#FFD600] text-[#0A0A0A]" : "bg-[#0A0A0A] text-[#FFD600]"}`}>
                      <Icon size={32} weight="fill" />
                    </div>
                    <div className="flex-1">
                      <div className="font-heading text-2xl font-bold uppercase">{s.label}</div>
                      <div className="text-sm text-[#A3A3A3]">{s.desc}</div>
                    </div>
                  </button>
                );
              })}
            </div>
            <button data-testid="onboarding-next" onClick={() => sector && setStep(2)}
              className="w-full mt-8 bg-[#FFD600] text-[#0A0A0A] h-16 text-xl font-black uppercase rounded-md hover:bg-[#E6C200] transition disabled:opacity-50 flex items-center justify-center gap-2"
              disabled={!sector}>
              Continua <ArrowRight size={22} weight="bold" />
            </button>
          </>
        )}
        {step === 2 && (
          <>
            <h1 className="font-heading text-5xl sm:text-6xl font-black uppercase tracking-tighter leading-none mb-3">Dati azienda</h1>
            <p className="text-[#A3A3A3] mb-8">Opzionali. Compaiono sui preventivi PDF.</p>
            <div className="space-y-4">
              <div>
                <label className="text-xs text-[#A3A3A3] uppercase tracking-wider font-bold mb-2 block">Nome azienda</label>
                <input data-testid="onb-company" value={companyName} onChange={(e)=>setCompanyName(e.target.value)}
                  placeholder="Es. Rossi Costruzioni Srl"
                  className="w-full bg-[#1A1A1A] border-2 border-[#333] h-14 text-lg text-white rounded-md px-4 focus:border-[#FFD600] focus:outline-none" />
              </div>
              <div>
                <label className="text-xs text-[#A3A3A3] uppercase tracking-wider font-bold mb-2 block">P.IVA</label>
                <input data-testid="onb-vat" value={vat} onChange={(e)=>setVat(e.target.value)}
                  placeholder="IT01234567890"
                  className="w-full bg-[#1A1A1A] border-2 border-[#333] h-14 text-lg text-white rounded-md px-4 focus:border-[#FFD600] focus:outline-none" />
              </div>
            </div>
            <div className="flex gap-3 mt-8">
              <button data-testid="onb-skip" onClick={finish} disabled={saving}
                className="flex-1 bg-[#1A1A1A] border-2 border-[#333] text-white h-16 text-xl font-bold uppercase rounded-md hover:border-[#666] transition disabled:opacity-50">
                Salta
              </button>
              <button data-testid="onb-finish" onClick={finish} disabled={saving}
                className="flex-1 bg-[#FFD600] text-[#0A0A0A] h-16 text-xl font-black uppercase rounded-md hover:bg-[#E6C200] transition disabled:opacity-50">
                {saving ? "..." : "Inizia"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
